export default __webpack_public_path__ + "static/media/settings.2ad8e8d2.svg";